import { render, staticRenderFns } from "./NewHomeAccountStatus.vue?vue&type=template&id=636e2068&scoped=true"
import script from "./NewHomeAccountStatus.vue?vue&type=script&lang=ts"
export * from "./NewHomeAccountStatus.vue?vue&type=script&lang=ts"
import style0 from "./NewHomeAccountStatus.vue?vue&type=style&index=0&id=636e2068&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e2068",
  null
  
)

export default component.exports